export const SET_ERROR = 'SET_ERROR';
export const SET_INIT_LOADING = 'SET_INIT_LOADING';
export const SET_LOADING = 'SET_LOADING';
export const SKIP_PAYMENT = 'SKIP_PAYMENT';

export const CLEAR_ERROR = 'CLEAR_ERROR';


// ERROR STUFF
export function clearError() {
  return { type: CLEAR_ERROR }
}

export function setError(error) {
  return { type: SET_ERROR, payload: error }
}

export function errorReducer(state, action) {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      }
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }

  return state;
}

// LOADING STUFF
export function setLoading(loading) {
  return { type: SET_LOADING, payload: loading }
}

export function setInitLoading(initLoading) {
  return { type: SET_INIT_LOADING, payload: initLoading }
}

export function loadingReducer(state, action) {
  switch (action.type) {
    case SET_INIT_LOADING:
      return {
        ...state,
        initLoading: action.payload,
      }
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }

  return state;
}

// PAYMENT SKIPPING
export function skipPayment() {
  return { type: SKIP_PAYMENT }
}

export function paymentSkipReducer(state, action) {
  switch (action.type) {
    case SKIP_PAYMENT:
      return {
        ...state,
        activeStep: 'preview',
        paymentSkipped: true,
      }
    default:
      return state
  }

  return state;
}
